<template>
<div>

    <b-button @click="beginLogin()" variant="success" class="btn-custom mb-3 fz-20">TIẾP TỤC VỚI TÀI KHOẢN ICAN
        <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" class="css-i6dzq1">
            <polyline points="13 17 18 12 13 7"></polyline>
            <polyline points="6 17 11 12 6 7"></polyline>
        </svg>
    </b-button>
</div>
</template>

<script>

export default {
    data() {
        return {
            GELoginOption: {
                scope: [
                    'openid',
                    'offline'
                ],
                response_type: 'code',
                login_hint: 'icanid',
            },
        }
    },
    mounted() {
    },
    methods: {
        beginLogin() {
            let uri = this.setting.ican_connect.ge_authorization_url
            uri += '?login_hint=' + this.GELoginOption.login_hint
            uri += '&scope=' + this.GELoginOption.scope.join(' ')
            uri += '&response_type=' + this.GELoginOption.response_type
            uri += '&redirect_uri=' + this.setting.ican_connect.ge_redirect_url
            uri += '&state=' + new Date().getTime()
            uri += '&client_id=' + this.setting.ican_connect.ge_client_id

            // console.log(uri)
            window.location.href = uri
        }
    },
    computed: {
        setting() {
            return this.$TestApp.getStartWith()
        }
    }
}
</script>


<style>

.btn-custom {
    font-size: 17px !important;
}

</style>